import { defineMessages } from 'react-intl';
import type { SupportCaseCategoryEnum } from '@foundershub/api-client';

export const supportCategoryLabels = defineMessages<SupportCaseCategoryEnum>({
  'activating-azure': {
    defaultMessage: 'Activating Azure',
    description: 'activating azure support category label',
  },
  'domain-or-business-verification': {
    defaultMessage: 'Domain or Business Verification',
    description: 'domain or business verification category label',
  },
  'activating-non-azure-benefits': {
    defaultMessage: 'Activating non-Azure benefits',
    description: 'activating non azure benefits support category label',
  },
  other: {
    defaultMessage: 'Other',
    description: 'other support category label',
  },
});
